export default __webpack_public_path__ + "static/media/meta.a5062909.jpg";